import React from 'react';
import { translate } from 'react-i18next';

import FancyCheckbox from 'components/account/FancyCheckbox.js';
import NotificationChannelCheckboxes from 'components/NotificationChannelCheckboxes.js';

// Multi-format sibling of NotificationChoices.js: same master-toggle-plus-
// options shape (mirroring the call-out section, and mobile's own per-event
// toggle), but with checkboxes underneath instead of radio buttons, since a
// multi-format row allows picking sms AND email at once rather than one
// channel at a time.
function MultiFormatNotificationToggle(props) {
  const optionsClass = props.enabled ? 'notificationOptions' : 'notificationOptions hide';

  return (
    <div className="notificationOptionCluster">
      <div className="primaryToggle">
        <FancyCheckbox
          disabled={false}
          label={props.label}
          checked={props.enabled}
          setting={props.notificationType}
          toggleSetting={props.toggleSetting}
        />
      </div>
      <div className={optionsClass}>
        <NotificationChannelCheckboxes
          name={props.settingName}
          user={props.user}
          validOptions={props.validOptions}
          currentPreference={props.currentPreference}
          lockedChannels={props.lockedChannels}
          onSettingsChange={props.onSettingsChange}
          contactInfoCallbackHandler={props.contactInfoCallbackHandler}
          activePage={props.activePage}
        />
      </div>
    </div>
  );
}

export default translate()(MultiFormatNotificationToggle);
